import * as React from 'react'; 
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { useContext } from "react";
import { ThemeContext } from "../ThemeContext";

interface AccordionItem {
    section: string;
    id: string;
}

export const AccordionBlok = () => {
    const { t } = useTranslation();
    const accordionItems: AccordionItem[] = [
        { section: 'section1', id: 'panel1' },
        { section: 'section2', id: 'panel2' },
        { section: 'section3', id: 'panel3' }
    ];
    const [theme] = useContext(ThemeContext) as ["light" | "dark", React.Dispatch<React.SetStateAction<"light" | "dark">>];

    return (
        <div className={`faq py-12 md:py-24 ${theme}`}> 
            <div className="container mx-auto px-4 py-8">
                <h2 className="text-center text-4xl sm:text-6xl  font-bold mb-4 sm:mb-8 uppercase">{t('faq.title')}</h2>
                <p className="text-center pb-4 sm:pb-12 max-w-2xl mx-auto"> {t('faq.description')}</p>
                <div className="max-w-2xl mx-auto"> 
                {accordionItems.map((item) => (
                    <Accordion className="accordion-item" key={item.id}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`${item.id}-content`}
                            id={`${item.id}-header`}
                        >
                            <Typography component="span">
                                {t(`faq.${item.section}.title`)}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-content italic">
                            <Typography>
                               "{t(`faq.${item.section}.content`)}"
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
                </div>
            </div>
        </div>
    )
}
